import { Typography, useTheme } from "@mui/material";
import React from "react";
import { BUSINESS_LOGO } from "../../config";

const ErrorFallback = ({ resetErrorBoundary }) => {
  const theme = useTheme();

  return (
    <div style={{ width: "100%", background: "#F2F2F7" }} role="alert">
      <div style={styles.container}>
        <img
          alt="logo"
          style={{ height: "100px", width: "100px" }}
          src={BUSINESS_LOGO}
        />
        <Typography style={styles.heading}>Something Went Wrong</Typography>
        <Typography style={styles.message}>
          We&apos;ve encountered an unexpected hiccup. Try refreshing your page
          to try again. If you&apos;re still seeing this message after trying
          again, contact us on{" "}
          <a
            href={`mailto:support@invoff.com`}
            style={{ color: theme?.palette?.primary?.main }}
          >
            {"support@invoff.com"}
          </a>{" "}
          for help.
        </Typography>
        {/* <Typography style={{ color: "red" }}>{error.message}</Typography> */}

        <button
          onClick={() => {
            window.location.href = "/";
          }}
          style={styles.button}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#F2F2F7",
    textAlign: "center",
    width: "700px",
    margin: "auto",
  },
  logo: {
    width: "150px",
    marginBottom: "20px",
  },
  heading: {
    fontSize: "2em",
    color: "#7A2FFE",
    marginBottom: "10px",
  },
  message: {
    fontSize: "1.2em",
    color: "#666",
    marginBottom: "20px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "1em",
    color: "#fff",
    backgroundColor: "#007bff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default ErrorFallback;
